import styles from "../../Styles/content.module.css";

const Content = ({ children }: any) => {
	return <div className={styles.content_main}>{children}</div>;
};

export default Content;
